// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // Eigene Backend-Basis; nur Aufrufe hierhin bekommen Schlüssel und Token.
  backendUrl: 'https://microservice-dot-dev-splicer-204213.ey.r.appspot.com',
  // Absender-Kennzeichen (x-apikey und ?auth=), kein Geheimnis.
  apiKey: 'khM0UwF7y0ItxRuazsE1RRRdX0WwLKPDjgF2PEfL',
  // ?auth= für /getSlackProfilePictureByNumber (anderer Schlüssel).
  slackAuthKey: 'VdjCKidks7qTEyuU6QeJtezZ3PeCHhZQ2yHJ3kPtcfTN8BjVqU'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
